import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useRequest } from 'hooks';

import Show from 'components/Show';
import Unsaved from 'components/Misc/Unsaved';
import { Form, Button } from 'components/Misc/Form';

import Basic from 'containers/Administrator/Users/Create/Basic';
import Address from 'containers/Administrator/Users/Create/Address';
import Teacher from 'containers/Administrator/Users/Create/Teacher';
import Student from 'containers/Administrator/Users/Create/Student';
import Parent from 'containers/Administrator/Users/Create/Parent';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Create = () => {
	// Use router's history
	const history = useHistory();

	// Finished creation
	const [created, setCreated] = useState(0);

	// Use user's creation store
	const [edited, user, onReset] = useUserCreateStore(state => [
		state.edited,
		state.user,
		state.onReset
	]);

	// Store request
	const [[progress], request] = useRequest('post', 'users');

	// Handle store cleanup
	useEffect(() => {
		return () => onReset();
	}, []);

	// Handle redirect on creation
	useEffect(() => {
		if (created) history.push(`/users/${created}`);
	}, [created]);

	// Handle submit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// TODO: Remove after test
		console.log(user);

		// Do not submit if request in progress
		if (progress) return;

		// Create formdata's instance
		const data = new FormData();

		// Append all plain text data as stringified object
		data.append('data', JSON.stringify(user));

		// Append avatar
		if (user.avatar) data.append('avatar', user.avatar);

		// Try to create user
		const [success, error] = await request(data);

		// Redirect on successful creation
		if (success) return setCreated(success.id);

		// TODO: Handle errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="p-4 mx-auto max-w-screen-md space-y-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			{/* Basic information for all user types */}
			<Basic />

			{/* Address information for all user types */}
			<Address />

			{/* Teacher specific data */}
			<Show if={user.role === 'teacher'}>
				<Teacher />
			</Show>

			{/* Student specific data */}
			<Show if={user.role === 'student'}>
				<Student />
			</Show>

			{/* Parent specific data */}
			<Show if={user.role === 'parent'}>
				<Parent />
			</Show>

			<div className="flex justify-end">
				<Button
					submit
					icon="done"
					value="Izveidot"
					theme="success"
					progress={progress}
				/>
			</div>

			{/* Show confirm on leave */}
			<Unsaved enabled={edited && !created} />
		</Form>
	);
};

export default Create;